/**
 * @file contains function that formats bytes to string
 */

/**
 * Function that formats bytes to string
 *
 * @param size size in bytes
 *
 * @returns    formatted string
 */
const formatBytesToString = (size: number) => {
  const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
  return (
    +(size / Math.pow(1024, i)).toFixed(2) * 1 +
    ' ' +
    ['B', 'kB', 'MB', 'GB', 'TB'][i]
  );
};

export default formatBytesToString;
